export function postMessage(type, data = {}) {
	window.top.postMessage(
		{
			type,
			...data
		},
		window.location
	);
}
